

import React from "react";

function Contact_Info() {
  return (
    <div id="contact_Info">
      <div className="section">
      <div className="container">
        <div
            className="col-lg-6"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <h2 className="font-weight-bold text-primary heading" style={{margin:"25px 0 100px"}}>
              Contact Us
            </h2>
          </div>
        <div className="row">
        
          {/* Contact Info Section */}
          <div
            className="col-lg-4 mb-5 mb-lg-0"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="contact-info">
              <div className="address mt-2">
                <i className="icon-room"></i>
                <h4 className="mb-2">Location:</h4>
                <p>
                  CORBILTEK PVT LTD
                  <br/>
                  21/152, Panadans, Kalamassery, Kochi University
                  <br />
                  Ernakulam, Kerala, 682022
                </p>
              </div>

              <div className="open-hours mt-4">
                <i className="icon-clock-o"></i>
                <h4 className="mb-2">Open Hours:</h4>
                <p>
                  Monday-Saturday:
                  <br />
                  10:00 AM - 7:30 PM
                </p>
              </div>

              <div className="email mt-4">
                <i className="icon-envelope"></i>
                <h4 className="mb-2">Email:</h4>
                <p>corbiltekpvtltd@gmail.com</p>
              </div>

              <div className="phone mt-4">
                <i className="icon-phone"></i>
                <h4 className="mb-2">Call:</h4>
                <p>+91-9496-152-037</p>
                <p>+91-9847-152-037</p>
              </div>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="row">
                <div className="col-6 mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name"
                  />
                </div>
                <div className="col-6 mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Your Email"
                  />
                </div>
                <div className="col-12 mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Subject"
                  />
                </div>
                <div className="col-12 mb-3">
                  <textarea
                    cols="30"
                    rows="7"
                    className="form-control"
                    placeholder="Message"
                  ></textarea>
                </div>

                <div className="col-12">
                  <input
                    type="submit"
                    value="Send Message"
                    className="btn btn-primary"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default Contact_Info;
